import React from 'react';
import PropTypes from 'prop-types';

import Input from '../../../../components/Input';
import messages from './messages';

const Website = ({ onChange, initialValue, formatMessage }) => (
  <Input
    data-cy="premium-Hem-Website-InputField"
    placeholder={formatMessage(messages.website)}
    value={initialValue.value}
    onChange={(e, { value }) => {
      onChange(e, { value });
    }}
  />
);

Website.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default Website;
